import './admin.scss';
import { Fragment, render, Component }                    from '@wordpress/element';
import { __ }                                             from '@wordpress/i18n';
import api                                                from '@wordpress/api';
import webyxIcons                                         from './icon/webyx-fe-icons';
import { Button, PanelBody, ToggleControl, SnackbarList } from '@wordpress/components';
import { dispatch, useDispatch, useSelect }               from '@wordpress/data';
import { store as noticesStore }                          from '@wordpress/notices';
const Notices = () => {
  const notices = useSelect(
    ( select ) =>
      select( noticesStore )
        .getNotices()
        .filter( ( notice ) => notice.type === 'snackbar' ),
    []
  );
  const { removeNotice } = useDispatch( noticesStore );
  return (
    <SnackbarList
      className = { 'webyx-fe-edit-site-notices' }
      notices   = { notices }
      onRemove  = { removeNotice }/>
  );
};
class Opts extends Component {
  constructor () {
    super( ...arguments );
    this.state = {
      webyx_fe_hide_admin_top_bar: true,
      webyx_fe_menu              : true,
      isAPILoaded                : false,
      webyx_fe_settings_pending : false,
    };
    this._handleOnClick = this._handleOnClick.bind( this );
  }
  _handleOnClick () {
    this.setState( {
      webyx_fe_settings_pending: true
    } );
    const {
      webyx_fe_hide_admin_top_bar,
      webyx_fe_menu
    } = this.state;
    const settings = new api.models.Settings( {
      [ 'webyx_fe_hide_admin_top_bar' ]: webyx_fe_hide_admin_top_bar ? 'true' : '',
      [ 'webyx_fe_menu'               ]: webyx_fe_menu               ? 'true' : '',
    } );
    settings.save().then(
      ( r ) => {
        this.setState( {
          webyx_fe_settings_pending: false
        } );
        dispatch( 'core/notices' ).createNotice(
          'success',
          __( 'Settings Saved', 'webyx-fe' ),
          {
            type: 'snackbar',
            isDismissible: true,
          }
        )
      }
    );
  }
  render () {
    const {
      webyx_fe_hide_admin_top_bar,
      webyx_fe_menu, 
      isAPILoaded,
      webyx_fe_settings_pending,
    } = this.state;
    if ( ! isAPILoaded ) {
      return (
        <div className = { 'webyx-fe-spinner-front-page' }>
          <div className = { 'webyx-fe-logo-container' }>
            <div className = { 'webyx-fe-circ-front-page' }></div>
            <span className = { 'webyx-fe-logo-icon' }>{ webyxIcons.webyx }</span>
          </div>
          <div className = { 'webyx-fe-txt-loader' }>{ 'LOADING' }</div>
        </div>
      );
    }
    return (
      <Fragment>
        <div className = { 'webyx-fe-header' } >
          <div className = { 'webyx-fe-container' }>
            <div className = { 'webyx-fe-title' }>
              <span className = { 'webyx-fe-icon-webyx' }>{ webyxIcons.webyx }</span>
              <h1>{ __( 'Webyx FE Settings', 'webyx-fe' ) }</h1>
            </div>
          </div>
        </div>
        <div className = { 'webyx-fe-main' }>
          <PanelBody
            initialOpen = { false }
            title       = { __( 'Hide WP admin top bar', 'webyx-fe' ) }
            icon        = { 'admin-plugins' }>
            <ToggleControl
              checked  = { webyx_fe_hide_admin_top_bar }
              help     = { __( 'Hide WP admin top bar in Webyx pages preview', 'webyx-fe' ) }
              label    = { __( 'Hide WP admin top bar', 'webyx-fe' ) }
              onChange = { ( webyx_fe_hide_admin_top_bar ) => this.setState( { webyx_fe_hide_admin_top_bar } ) }/>
          </PanelBody>
          <PanelBody
            initialOpen = { false }
            title       = { __( 'Webyx menu', 'webyx-fe' ) }
            icon        = { 'admin-plugins' }>
            <ToggleControl
              checked  = { webyx_fe_menu }
              help     = { __( 'Enable Webyx menu "Display location" in Appearance/Menus/Menu structure/Menu settings', 'webyx-fe' ) }
              label    = { __( 'Enable Webyx menu', 'webyx-fe' ) }
              onChange = { ( webyx_fe_menu ) => this.setState( { webyx_fe_menu } ) }/>
          </PanelBody>
          <Button 
            className = { `webyx-fe-save-settings-btn${ webyx_fe_settings_pending ? ' webyx-fe-is-busy' : ''}` } 
            isBusy    = { webyx_fe_settings_pending } 
            onClick = { this._handleOnClick }>
            { __( 'Save Settings', 'webyx-fe' ) }
          </Button>
        </div>
        <div className = { 'webyx-fe-notices' } >
          <Notices/>
        </div>
      </Fragment>
    )
  }
  componentDidMount () {
    api.loadPromise.then( () => {
      this.settings = new api.models.Settings();
      const { isAPILoaded } = this.state;
      if ( isAPILoaded === false ) {
        this.settings.fetch().then( ( response ) => {
          this.setState( {
            webyx_fe_hide_admin_top_bar: Boolean( response[ 'webyx_fe_hide_admin_top_bar' ] ),
            webyx_fe_menu              : Boolean( response[ 'webyx_fe_menu' ] ),
            isAPILoaded                 : true,
          } );
        } );
      }
    } );
  }
}
document.addEventListener( 'DOMContentLoaded', () => {
  const rootEl = document.getElementById( 'webyx-fe-settings' );
  if ( rootEl ) {
    render(
      <Opts/>,
      rootEl
    );
  }
});